module.exports = __webpack_public_path__ + "static/media/OurStory-PinkWave.9cd844aa.svg";